import React from 'react';
import Card from './ui/Card.jsx';
import { apiFetch } from '../api.js';
import { sanitizeCmsHtml } from '../lib/sanitizeCmsHtml.js';

export default function CMSPage({ pageName, title, subtitle, emptyMessage }) {
  const [state, setState] = React.useState({
    loading: true,
    error: '',
    page: null
  });

  React.useEffect(() => {
    let active = true;
    setState({ loading: true, error: '', page: null });

    const load = async () => {
      const list = await apiFetch('/api/pages');
      const items = list?.items || [];
      const match = items.find((item) =>
        String(item.name || '').trim().toLowerCase() === String(pageName || '').trim().toLowerCase()
      );
      if (!match) {
        if (!active) return;
        setState({ loading: false, error: '', page: null });
        return;
      }
      const detail = await apiFetch(`/api/pages/${match.id}`);
      if (!active) return;
      setState({ loading: false, error: '', page: detail });
    };

    load().catch((err) => {
      if (!active) return;
      setState({ loading: false, error: err?.message || 'Failed to load content.', page: null });
    });

    return () => {
      active = false;
    };
  }, [pageName]);

  const safeContent = React.useMemo(() => sanitizeCmsHtml(state.page?.content || ''), [state.page?.content]);

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1>{title}</h1>
          {subtitle ? <p className="subtle">{subtitle}</p> : null}
        </div>
      </div>

      {state.error ? <div className="alert error">{state.error}</div> : null}

      {state.loading ? (
        <p className="subtle">Loading...</p>
      ) : (
        <Card title={state.page?.name || title}>
          {state.page?.content ? (
            <div className="cms-content" dangerouslySetInnerHTML={{ __html: safeContent }} />
          ) : (
            <p className="subtle">{emptyMessage || 'Content is not available yet.'}</p>
          )}
        </Card>
      )}
    </div>
  );
}
